import { Injectable } from '@angular/core';
import { type SettingSpotConfigurationIdentifier } from '@clean-code/models';
import { DataTableParameters, ID } from '@clean-code/models/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import {
  DataServiceReturn,
  EditSearchDataService,
} from '@clean-code/shared/util/util-data-service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SettingSpotConfigurationIdentifierService
  implements EditSearchDataService<SettingSpotConfigurationIdentifier>
{
  constructor(private graphqlService: GraphqlService) {}
  getAll$(
    params?: DataTableParameters
  ): Observable<DataServiceReturn<SettingSpotConfigurationIdentifier>> {
    throw new Error('Method not implemented.');
  }

  public getAllSettingSpotConfigurationIdentifier$(
    settingSpotConfigurationId: ID
  ): Observable<SettingSpotConfigurationIdentifier[]> {
    const query = `
        query ($spotConfigurationId: Int!) {
            settingSpotConfigurationIdentifierGetAll(spotConfigurationId: $spotConfigurationId) {
                id
                identifier
                hour
            }
        }
    `;

    const variables = { spotConfigurationId: +settingSpotConfigurationId };
    return this.graphqlService.query<SettingSpotConfigurationIdentifier[]>(
      query,
      variables
    );
  }

  public getById$(id: ID): Observable<SettingSpotConfigurationIdentifier> {
    const query = `
        query ($id: Int!)
        {
            settingSpotConfigurationIdentifierGetById(id: $id) {
                id
                identifier
                hour
            }
        }
    `;

    const variables = { id: +id };
    return this.graphqlService.query<SettingSpotConfigurationIdentifier>(
      query,
      variables
    );
  }

  public add$(
    settingSpotConfigurationIdentifier: SettingSpotConfigurationIdentifier
  ): Observable<SettingSpotConfigurationIdentifier> {
    const input = {
      identifier: settingSpotConfigurationIdentifier.identifier,
      hour: settingSpotConfigurationIdentifier.hour,
      spotConfigurationId: +settingSpotConfigurationIdentifier.spotConfigurationId,
    };

    const mutation = `
        mutation ($input: AddSettingSpotConfigurationIdentifierInput!){
            addSettingSpotConfigurationIdentifier(input: $input){
              id
              identifier
              hour
            }
          }
    `;
    return this.graphqlService.query<SettingSpotConfigurationIdentifier>(
      mutation,
      { input }
    );
  }

  public update$(
    settingSpotConfigurationIdentifier: SettingSpotConfigurationIdentifier
  ): Observable<SettingSpotConfigurationIdentifier> {
    const input = {
      id: +settingSpotConfigurationIdentifier.id,
      identifier: settingSpotConfigurationIdentifier.identifier,
      hour: settingSpotConfigurationIdentifier.hour,
      spotConfigurationId: +settingSpotConfigurationIdentifier.spotConfigurationId,
    };

    const mutation = `
        mutation ($input: UpdateSettingSpotConfigurationIdentifierInput!){
            updateSettingSpotConfigurationIdentifier(input: $input){
              id
              identifier
              hour
            }
          }
    `;
    return this.graphqlService.query<SettingSpotConfigurationIdentifier>(
      mutation,
      { input }
    );
  }

  public delete$(id: ID): Observable<boolean> {
    const query = `
        mutation ($id: Int!) {
            deleteSettingSpotConfigurationIdentifier(id: $id)
        }
    `;

    return this.graphqlService.mutation<boolean>(query, { id: +id });
  }
}
